export default __webpack_public_path__ + "static/media/621563901c64e3afd45172d8b0643d22.f8f89c4f.png";